import { useEffect, useState } from 'react'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../base/customHooks/componentHOC'
import { IAppleDepEnvironment } from '../../../MySpecial/AppleDep/models/models'
import { GetAppleDepEnvironmentApi } from '../../../MySpecial/AppleDep/services/appleDepApi'
import AdminTransactionsTab from './AdminTransactionsTab'
import DealerSettingsTab from './DealerSettingsTab'
import DeviceOperationsTab from './DeviceOperationsTab'
import '../../../MySpecial/AppleDep/styles.scss'

type AdminTab = 'resellers' | 'transactions' | 'operations'

/**
 * Index admin — Apple DEP yönetimi.
 *
 * Bayi ekranı yalnızca OR (kayıt) gönderir. İade (RE), düzeltme (OV) ve iptal (VD)
 * Apple'ın şartı gereği kısıtlı bir ekipte olmalıdır; bu işlemler burada yapılır.
 * Ham JSON istek/yanıt kayıtları da buradan görüntülenir — Apple CDEP eskalasyon
 * taleplerinde zorunludur.
 */
function AppleDepOperation(props: BaseComponentWithContextProps) {
  const [activeTab, setActiveTab] = useState<AdminTab>('resellers')
  const [environment, setEnvironment] = useState<IAppleDepEnvironment | undefined>(undefined)

  useEffect(() => {
    const loadEnvironment = async () => {
      try {
        const api: GetAppleDepEnvironmentApi = new GetAppleDepEnvironmentApi({})
        setEnvironment(await api.getEnvironment())
      } catch {
        // Ortam bandı gösterilemezse ekran çalışmaya devam eder.
      }
    }

    loadEnvironment()
  }, [])

  const tabs: { key: AdminTab; label: string }[] = [
    { key: 'resellers', label: 'Bayi Ayarları' },
    { key: 'transactions', label: 'Gönderimler' },
    { key: 'operations', label: 'Cihaz İşlemleri (RE / OV / VD)' },
  ]

  return (
    <div className='appleDepPage appleDepAdminPage'>
      <div className='appleDepHeader'>
        <h4>APPLE DEP — Yönetim</h4>
        <p className='appleDepHeaderText'>
          Bayi bazlı Organization ID ayarları, tüm bayilerin gönderimleri ve Apple'ın kısıtlı ekipte
          olmasını şart koştuğu iade / düzeltme / iptal işlemleri.
        </p>
      </div>

      {environment && (
        <div className={`appleDepEnvBanner ${environment.IsLive === 1 ? 'appleDepEnvLive' : 'appleDepEnvTest'}`}>
          <span className='appleDepEnvTag'>{environment.IsLive === 1 ? 'CANLI ORTAM' : 'TEST ORTAMI'}</span>
          <span className='appleDepEnvNote'>{environment.BaseUrl}</span>
          <span className='appleDepEnvNote'>ShipTo: {environment.ShipTo || 'tanımsız'}</span>
          <span className='appleDepEnvNote'>
            Sertifika: {environment.HasCertificate ? 'tanımlı' : 'tanımsız'}
          </span>
          <span className='appleDepEnvNote'>Sipariş no kaynağı: {environment.OrderNumberSource}</span>
          {environment.UseFakeClient && (
            <span className='appleDepEnvNote'>
              <strong>Simülasyon modu:</strong> Apple'a gerçek çağrı yapılmıyor.
            </span>
          )}
        </div>
      )}

      <ul className='appleDepTabs'>
        {tabs.map(tab => (
          <li
            key={tab.key}
            className={activeTab === tab.key ? 'appleDepTabActive' : ''}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </li>
        ))}
      </ul>

      <div className='appleDepTabContent'>
        {activeTab === 'resellers' && <DealerSettingsTab {...props} />}
        {activeTab === 'transactions' && <AdminTransactionsTab {...props} />}
        {activeTab === 'operations' && <DeviceOperationsTab {...props} environment={environment} />}
      </div>
    </div>
  )
}

export default componentWithContext(AppleDepOperation)
